export enum DrawingMode {
    Point="Point",
    LineString="LineString",
    Polygon="Polygon",
    Circle="Circle"
}